import * as React from "react";
import styled from "styled-components";
import ContentSection from "../../components/about/content-section";
import ImageSection from "../../components/about/image-sectioin";
import { useEffect } from "react";
import AOS from "aos";

const TrackPerformance = () => {
  useEffect(() => {
    // Initialize AOS with settings to only animate once
    AOS.init({
      once: true, // This is the key setting - animations will only happen once
      mirror: false, // Don't mirror animations when scrolling back up
      duration: 800,
      offset: 100, // Controls when the animation triggers
      easing: "ease-out"
    });

    // Refresh AOS on component mount
    AOS.refresh();
  }, []);
  return (
    <StudySection>
      <div data-aos="fade-in" data-aos-duration="600">
        <ImageSection
          imageSrc={"/assets/home/track.webp"}
          imageAlt={"Track Note"}
        />
      </div>
      <div data-aos="fade-in" data-aos-duration="600">
        <ContentSection
          imageSrc={"/assets/home/track-note.png"}
          imageAlt={"Track Performance"}
          title={"Track Your Performance"}
          description={
            "Practice with original questions that match the style and content of your exam, complete with detailed explanations and references to key textbooks."
          }
        />
      </div>
    </StudySection>
  );
};

const StudySection = styled.section`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 96px 32px 16px;
  max-width: 1456px;
  margin: 0 auto;
  width: 100%;
  gap: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 32px 16px;
    text-align: center;
  }
`;

export default TrackPerformance;
